var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0712 25.3C27.56 25.7875 27.56 26.5875 27.0712 27.075C26.5837 27.5625 25.7913 27.5625 25.3025 27.075L20.0075 21.7751L14.675 27.1124C14.1825 27.5999 13.385 27.5999 12.8925 27.1124C12.4013 26.6124 12.4013 25.8125 12.8925 25.325L18.225 19.9875L12.93 14.7C12.4412 14.2125 12.4412 13.4125 12.93 12.925C13.4162 12.4375 14.2087 12.4375 14.6975 12.925L19.9925 18.2249L25.365 12.85C25.8575 12.3625 26.6537 12.3625 27.1462 12.85C27.6375 13.35 27.6375 14.1375 27.1462 14.6375L21.775 20.0125L27.0712 25.3ZM20 0C8.95375 0 0 8.95 0 20C0 31.05 8.95375 40 20 40C31.0462 40 40 31.05 40 20C40 8.95 31.0462 0 20 0Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleSvg);
export default __webpack_public_path__ + "static/media/cross-circle-svg.b4d0383d42c2f83e06351f37fed885c5.svg";
export { ForwardRef as ReactComponent };